<div class="e-signature-dialog">
  <div class="dialog-header">
    <!-- <h3>Electronic Signature Required</h3> -->
    
    <!-- Name and Date Fields -->
    <div class="form-fields">
      <div class="form-field">
        <label for="signatureName">Name <span class="required">*</span></label>
        <input 
          id="signatureName"
          type="text" 
          [(ngModel)]="signatureName" 
          maxlength="50"
          placeholder="Enter your full name"
          class="form-control"
          required>
        <small class="character-count">{{ signatureName.length }}/50</small>
      </div>

      <div class="form-field">
        <label for="signatureDate">Date <span class="required">*</span></label>
        <p-calendar 
          id="signatureDate"
          [(ngModel)]="signatureDate" 
          [showIcon]="true"
          dateFormat="mm/dd/yy"
          placeholder="Select date"
          [readonlyInput]="true">
        </p-calendar>
      </div>
    </div>

    <p class="dialog-subtitle">Please provide your electronic signature to submit this form</p>
  </div>

  <div class="dialog-content">
    <div class="signature-container">
      <div class="signature-pad-wrapper">
        <canvas #signaturePad width="500" height="200"></canvas>
      </div>
      
      <div class="signature-actions">
        <button 
          type="button" 
          class="btn btn-secondary"
          (click)="clearSignature()">
          Clear Signature
        </button>
      </div>
    </div>

    <div class="signature-instructions">
      <p><strong>Instructions:</strong></p>
      <ul>
        <li>Draw your signature in the box above</li>
        <li>Use your mouse or touch device to sign</li>
        <li>Click "Clear Signature" to start over if needed</li>
        <li>Your signature is required to submit this form</li>
      </ul>
    </div>
  </div>

  <div class="dialog-footer">
    <button 
      type="button" 
      class="btn btn-secondary"
      (click)="cancel()">
      Cancel
    </button>
    <button 
      type="button" 
      class="btn btn-primary"
      [disabled]="!isFormValid()"
      (click)="submitSignature()">
      Submit with Signature
    </button>
  </div>
</div> 